import { useTranslation } from 'react-i18next'

import { NewsboardPostAction } from '../NewsboardPostAction'
import { QA_NAME_AUTOMATE_ACTION } from '../NewsboardPostFooter.constants'

import AutomateIcon from '../../../../../icons/automate.svg'

function NewsboardPostAutomate() {
  const { t } = useTranslation()

  return (
    <NewsboardPostAction
      Icon={AutomateIcon}
      qaName={QA_NAME_AUTOMATE_ACTION}
      title={t('Newsboard.AutomateActionKey')}
      tooltip={t('Newsboard.AutomateActionTooltipKey')}
    />
  )
}

export default NewsboardPostAutomate
